import { render, staticRenderFns } from "./TableHeading.vue?vue&type=template&id=3e55484d&scoped=true&"
import script from "./TableHeading.vue?vue&type=script&lang=js&"
export * from "./TableHeading.vue?vue&type=script&lang=js&"
import style0 from "./TableHeading.vue?vue&type=style&index=0&id=3e55484d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e55484d",
  null
  
)

export default component.exports